import React from "react";
import { RatingButton } from "../../shared/RatingButton";
import { NOT_SURE, THUMBS_DOWN, THUMBS_UP } from "~/constants/globals";
import * as styles from "./index.module.scss";

export function ActionButtons({
  onClick,
  currentRating = NOT_SURE,
  hideNotSureButton = false,
}) {
  const ratingClickHandler = (rating) => {
    if (rating === "positive") {
      onClick(THUMBS_UP);
      return;
    }

    onClick(THUMBS_DOWN);
  };

  let value = "neutral";
  if (currentRating === THUMBS_UP) {
    value = "positive";
  } else if (currentRating === THUMBS_DOWN) {
    value = "negative";
  }

  return (
    <div className={styles.actionButtons}>
      <RatingButton
        customClass={styles.thumbButtons}
        onClick={ratingClickHandler}
        value={value}
      />
      {!hideNotSureButton && (
        <button
          type="button"
          data-testid="quiz-v2-actionbuttons-not-sure"
          onClick={() => onClick(NOT_SURE)}
          className={styles.notSureButton}
        >
          I&apos;m not sure
        </button>
      )}
    </div>
  );
}
